<template>
    <!-- Bloque de código de /developers con botón para copiar. -->
    <figure class="dev-code">
        <figcaption class="dev-code__bar">
            <span class="dev-code__title">{{ titulo || lang.toUpperCase() }}</span>
            <button type="button" class="dev-code__copy" :aria-label="copiado ? 'Copiado' : `Copiar ${titulo || 'código'}`" @click="copiar">
                <i :class="copiado ? 'fas fa-check' : 'far fa-copy'" aria-hidden="true" />
                {{ copiado ? 'Copiado' : 'Copiar' }}
            </button>
        </figcaption>
        <pre class="dev-code__pre" tabindex="0"><code>{{ code }}</code></pre>
        <span class="sr-only" aria-live="polite">{{ copiado ? 'Código copiado al portapapeles' : '' }}</span>
    </figure>
</template>

<script>
export default {
    name: 'DevCode',
    props: {
        code: { type: String, required: true },
        lang: { type: String, default: 'text' },
        titulo: { type: String, default: '' },
    },
    data() {
        return { copiado: false };
    },
    beforeDestroy() {
        clearTimeout(this.timer);
    },
    methods: {
        async copiar() {
            try {
                if (navigator.clipboard && window.isSecureContext) {
                    await navigator.clipboard.writeText(this.code);
                } else {
                    // http / navegadores viejos
                    const ta = document.createElement('textarea');
                    ta.value = this.code;
                    ta.setAttribute('readonly', '');
                    ta.style.position = 'fixed';
                    ta.style.opacity = '0';
                    document.body.appendChild(ta);
                    ta.select();
                    document.execCommand('copy');
                    document.body.removeChild(ta);
                }
                this.copiado = true;
                clearTimeout(this.timer);
                this.timer = setTimeout(() => { this.copiado = false; }, 1800);
            } catch (e) {
                console.error('[DevCode] No se pudo copiar', e);
            }
        },
    },
};
</script>

<style scoped lang="scss">
.dev-code {
    margin: 14px 0 20px;
    border-radius: 12px;
    overflow: hidden;
    background: #1d1a17;
    border: 1px solid #2e2924;

    &__bar {
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 8px 12px 8px 16px;
        background: #26221e;
        border-bottom: 1px solid #2e2924;
    }
    &__title { color: #ff9a3d; font: 600 .78rem/1 'Roboto Mono', monospace; letter-spacing: .02em; }
    &__copy {
        display: inline-flex; align-items: center; gap: 6px;
        padding: 5px 10px;
        border: 1px solid #4a3f35; border-radius: 6px;
        background: transparent; color: #f5ede6;
        font-size: .78rem; font-weight: 600; cursor: pointer;
        &:hover { background: #e8640a; border-color: #e8640a; color: #fff; }
        &:focus-visible { outline: 2px solid #FC7010; outline-offset: 2px; }
    }
    &__pre {
        margin: 0;
        padding: 16px;
        overflow-x: auto;
        color: #f5ede6;
        font: 400 .85rem/1.6 'Roboto Mono', ui-monospace, SFMono-Regular, Menlo, monospace;
        white-space: pre;
        &:focus-visible { outline: 2px solid #FC7010; outline-offset: -2px; }
        code { color: inherit; background: none; padding: 0; font: inherit; }
    }
}
.sr-only {
    position: absolute; width: 1px; height: 1px; padding: 0; margin: -1px;
    overflow: hidden; clip: rect(0, 0, 0, 0); white-space: nowrap; border: 0;
}
</style>
